var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 14,
  r: 2.6,
  fill: "#3c4652"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 29.5,
  r: 2.6,
  fill: "#3c4652"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 29.5,
  r: 2.6,
  fill: "#3c4652"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 24.5,
  r: 8,
  fill: "#5f7d95"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 24.5,
  r: 5.8,
  fill: "#6e91ad"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 30.5,
  y: 6,
  width: 9.5,
  height: 6.5,
  rx: 2.2,
  fill: "#5a8fd8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m33 12.3-1.4 2.5 3.2-1.7z",
  fill: "#5a8fd8"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 35.5,
  y: 11.5,
  width: 7.5,
  height: 5.5,
  rx: 2,
  fill: "#23967f"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m41 16.8 1.2 2.2-3-1.4z",
  fill: "#23967f"
});

function SvgHuddles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuddles);
export default __webpack_public_path__ + "static/media/huddles.398cb356d4def903f68e5391ee93292f.svg";
export { ForwardRef as ReactComponent };